import {
  Sprout, Car, Layers, LayoutGrid, CloudRain, Home, Droplets,
  Trees, Wrench, Brush, Trash2, Sun, Shovel, Sparkles,
} from "lucide-react";

const MAP = {
  sprout: Sprout, car: Car, layers: Layers, "layout-grid": LayoutGrid,
  "cloud-rain": CloudRain, home: Home, droplets: Droplets, trees: Trees,
  wrench: Wrench, brush: Brush, trash: Trash2, sun: Sun, shovel: Shovel,
  sparkles: Sparkles,
};

export const ICON_OPTIONS = Object.keys(MAP);

export default function ServiceIcon({ name, className = "h-6 w-6" }) {
  const Ic = MAP[name] || Sparkles;
  return <Ic className={className} />;
}
